import { graphql } from "gql.tada";
import { RichTextFragment } from "../fragments/RichTextFragment";

export const SolutionsHeroById = graphql(
  /* GraphQL */ `
    query SolutionsHeroById($locale: String, $preview: Boolean, $id: String!) {
      solutionsHero(id: $id, preview: $preview, locale: $locale) {
        ...SolutionsHeroFragment
      }
    }

    fragment SolutionsHeroFragment on SolutionsHero {
      solutionsHeroTitle: title
      bodyRichText {
        ...RichTextFragment
      }
      solutionsHeroEyebrowImages: eyebrowImagesCollection {
        items {
          url
          contentType
        }
      }
      fullWidthImage {
        url
        contentType
      }
    }
  `,
  [RichTextFragment]
);
